/* kb-track.js: tracking voor de eigen aanbevelingsengine van K-Beauty Store.
   Regels (CLAUDE.md): geen cookie en geen events zonder analytics-consent; alleen een anoniem bezoekers-id;
   cart-attribuut __kb_vid zodat de orderwebhook de bezoeker kent. Werkt zonder afhankelijkheden. */
(function () {
  'use strict';
  var C = window.KBREC;
  if (!C || !C.api) return;

  var COOKIE = 'kb_vid';
  var COOKIE_DAYS = 395; // 13 maanden
  var queue = [];
  var flushTimer = null;
  var consent = null;   // null = onbekend, true/false
  var vid = null;
  var sid = null;

  /* ---------- consent ---------- */
  function readConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    // Zonder Customer Privacy API: alleen tracken als de banner-variabele van Hello Retail-tijd dat toelaat.
    if (typeof window.trackingOptOut !== 'undefined') return !window.trackingOptOut;
    return null;
  }

  function withConsent(cb) {
    var c = readConsent();
    if (c !== null) return cb(c);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(err ? false : !!readConsent());
      });
    } else {
      cb(false);
    }
  }

  document.addEventListener('visitorConsentCollected', function (e) {
    var allowed = e && e.detail && (e.detail.analyticsAllowed === true || e.detail.analytics === true);
    if (allowed && !consent) start(true);
  });

  /* ---------- id's ---------- */
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0; return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value) {
    var host = location.hostname.replace(/^www\./, '');
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + COOKIE_DAYS * 86400 + '; path=/; domain=.' + host + '; SameSite=Lax; Secure';
  }
  function ensureIds() {
    vid = getCookie(COOKIE);
    if (!vid) { vid = uuid(); setCookie(COOKIE, vid); }
    // Sessie-markering voor de custom pixel: het theme meet zelf, dus de pixel slaat bekeken en winkelwagen over.
    try { document.cookie = 'kb_t=1; path=/; SameSite=Lax; Secure'; } catch (e) {}
    try { localStorage.setItem(COOKIE, vid); } catch (e) {}
    try {
      sid = sessionStorage.getItem('kb_sid');
      if (!sid) { sid = uuid(); sessionStorage.setItem('kb_sid', sid); }
    } catch (e) { sid = uuid(); }
  }

  /* ---------- verzenden ---------- */
  function send(useBeacon) {
    if (!consent || !queue.length) return;
    var body = JSON.stringify({ key: C.key, visitor_id: vid, session_id: sid, locale: C.locale, events: queue.splice(0, 200) });
    var url = C.api + '/events';
    if (useBeacon && navigator.sendBeacon) {
      // sendBeacon kan geen application/json-header zetten; de server accepteert text/plain met JSON-body.
      if (navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
    }
    try {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, mode: 'cors' }).catch(function () {});
    } catch (e) {}
  }
  function track(ev) {
    ev.page_type = ev.page_type || C.pageType;
    queue.push(ev);
    if (!consent) return;
    clearTimeout(flushTimer);
    flushTimer = setTimeout(function () { send(false); }, 800);
  }
  window.addEventListener('pagehide', function () { send(true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(true); });

  /* ---------- cart ---------- */
  // Het attribuut hoort bij een cart. Ontstaat er een nieuwe cart (na een order of leegmaken), dan opnieuw zetten:
  // de sleutel in sessionStorage is bezoekers-id plus cart-token. Privé-attributen (__) zijn niet zichtbaar in /cart.js.
  var attrSet = false, cartToken = C.cartToken || '';
  function setCartAttribute() {
    var mark = vid + '|' + cartToken;
    if (attrSet === mark) return;
    attrSet = mark;
    try {
      if (sessionStorage.getItem('kb_attr') === mark) return;
    } catch (e) {}
    fetch((C.localePrefix === '/' ? '' : C.localePrefix) + '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ attributes: { __kb_vid: vid } })
    }).then(function () { try { sessionStorage.setItem('kb_attr', mark); } catch (e) {} }).catch(function () { attrSet = false; });
  }
  function sendCart(items) {
    if (!consent) return;
    var body = JSON.stringify({ key: C.key, visitor_id: vid, session_id: sid, locale: C.locale, events: [], cart: { items: items } });
    fetch(C.api + '/events', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, mode: 'cors' }).catch(function () {});
    setCartAttribute();
  }
  function cartItemsFromResponse(cart) {
    return (cart && cart.items ? cart.items : []).map(function (i) {
      return { product_id: i.product_id, variant_id: i.variant_id || i.id, quantity: i.quantity };
    });
  }
  function refreshCart() {
    fetch((C.localePrefix === '/' ? '' : C.localePrefix) + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        C.cart = cartItemsFromResponse(cart);
        cartToken = (cart && cart.token) || '';
        sendCart(C.cart);
        document.dispatchEvent(new CustomEvent('kb:cart', { detail: { items: C.cart } }));
      }).catch(function () {});
  }
  // Blockshop-events (bouwplan 1): productAdded, updated, drawer:updateHtml.
  document.addEventListener('theme:cart:productAdded', function (e) {
    var d = e && e.detail;
    if (d && d.product_id) track({ type: 'cart', product_id: d.product_id, placement: d.kb_placement || null, request_id: d.kb_request_id || null });
    refreshCart();
  });
  // Blockshop vuurt theme:cart:updated op window (window.trigger); de fetch-onderschepping hieronder vangt dezelfde wijziging,
  // dus die refresh wordt via cartTimer samengevoegd.
  window.addEventListener('theme:cart:updated', function () { clearTimeout(cartTimer); cartTimer = setTimeout(refreshCart, 300); });
  // Theme-onafhankelijk: elke fetch naar /cart/add, /cart/change, /cart/update of /cart/clear (ook zonder .js) leidt tot
  // een refresh, zodat het cart-attribuut en de cart-events ook werken in themes zonder Blockshop-events (bv. Dawn).
  // Onze eigen attribuut-update (body met __kb_vid) telt niet mee.
  var cartTimer = null;
  if (window.fetch && !window.fetch.__kb) {
    var origFetch = window.fetch;
    var patched = function (input, init) {
      var p = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var body = init && typeof init.body === 'string' ? init.body : '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && body.indexOf('__kb_vid') < 0) {
          p.then(function () { clearTimeout(cartTimer); cartTimer = setTimeout(refreshCart, 300); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
    patched.__kb = true;
    window.fetch = patched;
  }

  /* ---------- recent bekeken (lokaal, voor directe weergave) ---------- */
  function rememberViewed(id) {
    try {
      var list = JSON.parse(localStorage.getItem('kb_recent') || '[]').filter(function (x) { return x !== id; });
      list.unshift(id);
      localStorage.setItem('kb_recent', JSON.stringify(list.slice(0, 20)));
      localStorage.removeItem('kb_recent_cleared');
    } catch (e) {}
  }

  /* ---------- start ---------- */
  var started = false;
  function start(allowed) {
    consent = allowed;
    if (!allowed) { queue = []; document.dispatchEvent(new CustomEvent('kb:ready', { detail: { consent: false } })); return; }
    if (started) { send(false); return; }
    started = true;
    ensureIds();

    if (C.pageType === 'product' && C.product) {
      track({ type: 'view', product_id: C.product.id });
      rememberViewed(C.product.id);
    } else if (C.pageType === 'search' && C.searchTerms) {
      track({ type: 'search', query: C.searchTerms, results_count: C.searchResults, extra: { source: 'page' } });
    } else {
      track({ type: 'view', extra: { collection: C.collection || undefined } });
    }
    // Liquid geeft cart.token niet (meer) mee; eerst het token ophalen, anders telt een nieuwe cart als al gezet.
    if (C.cart && C.cart.length) {
      if (cartToken) setCartAttribute();
      else fetch((C.localePrefix === '/' ? '' : C.localePrefix) + '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartToken = (cart && cart.token) || ''; if (cartToken) setCartAttribute(); }).catch(function () {});
    }
    send(false);
    document.dispatchEvent(new CustomEvent('kb:ready', { detail: { consent: true, visitor: vid } }));
  }

  /* ---------- publieke API voor kb-recs.js en de zoekoverlay ---------- */
  window.KBTrack = {
    track: track,
    visitor: function () { return consent ? vid : null; },
    consent: function () { return consent; },
    recent: function () { try { return JSON.parse(localStorage.getItem('kb_recent') || '[]'); } catch (e) { return []; } },
    cart: function () { return C.cart || []; },
    flush: function () { send(false); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { withConsent(start); });
  else withConsent(start);
})();
